import { PropsWithoutRef } from 'react'

import Icon from '@ant-design/icons'
import { IconBaseProps } from '@ant-design/icons/lib/components/Icon'

import { TimeSvg } from './TimeSvg'

export const EaTimeIcon = (props: PropsWithoutRef<IconBaseProps>) => (
  <Icon component={TimeSvg} {...props} />
)
